/**
 * FR-22 — research-data consent (SoW Bagian 16).
 *
 * ⚠ DRAFT WORDING. The consent text is a client deliverable (URS §9 item 5)
 * and has not arrived. This draft exists so the flow can be built and tested;
 * it must be replaced before real patients are asked. When it is:
 *
 *   1. replace CONSENT_PARAGRAPHS with the client's text, verbatim;
 *   2. change CONSENT_VERSION (e.g. to '2026-10-client-v1').
 *
 * Step 2 is what re-asks everyone who answered the draft. A stored answer is
 * only ever valid for the version it was given to.
 */

export const CONSENT_VERSION = 'draft-2026-09';

/** True while the text above is still the placeholder. Shown on the screen. */
export const CONSENT_IS_DRAFT = CONSENT_VERSION.startsWith('draft');

export const CONSENT_TITLE = 'Persetujuan penggunaan data untuk penelitian';

export const CONSENT_PARAGRAPHS: string[] = [
  'DiaryDM mencatat gula darah, insulin, lokasi suntikan, dan data klinis Adik untuk ' +
    'membantu Adik, orang tua, dan dokter memantau diabetes.',
  'Tim peneliti ingin memakai data ini, tanpa nama dan tanpa data yang bisa menunjukkan ' +
    'siapa Adik, untuk penelitian agar perawatan diabetes pada anak menjadi lebih baik.',
  'Orang tua atau wali boleh setuju atau tidak setuju. Jika tidak setuju, Adik tetap bisa ' +
    'memakai semua fitur DiaryDM seperti biasa, dan data Adik tidak dipakai untuk penelitian.',
  'Pilihan ini bisa diubah kapan saja lewat menu Profil.'
];

/**
 * Whether this profile still has to answer the current consent text.
 *
 * Only patients are asked — the consent is about a child's data being used
 * for research. A doctor or admin account holds no such data.
 */
export function needsResearchConsent(
  profile: { role?: string | null; research_consent_version?: string | null } | null
): boolean {
  return profile?.role === 'patient' && profile.research_consent_version !== CONSENT_VERSION;
}

/** Display label for a stored answer, for the profile page and exports. */
export function researchConsentLabel(
  profile: { research_consent?: boolean | null; research_consent_version?: string | null } | null
): string {
  if (!profile || profile.research_consent === null || profile.research_consent === undefined) {
    return 'Belum ditanya';
  }
  const answer = profile.research_consent ? 'Setuju' : 'Tidak setuju';
  return profile.research_consent_version === CONSENT_VERSION
    ? answer
    : `${answer} (versi lama)`;
}
